// Каким входом пользуются на этом компьютере.
//
// Входов два: операторский (/login) и клиентский (/client/login) — у них
// разные токены и разные разделы. На проходной терминала за компьютером
// всегда сотрудник, у грузовладельца — всегда клиент, и каждый раз искать
// свою форму незачем. Выбор хранится в браузере: это свойство рабочего
// места, а не сессии, и после выхода он должен пережить закрытие вкладки.

const STORAGE_KEY = 'sts-login-mode'

// staff  — вход оператора терминала
// client — вход грузовладельца в личный кабинет
export const LOGIN_MODES = ['staff', 'client']

const DEFAULT_MODE = 'staff'

export const LOGIN_PATHS = {
  staff: '/login',
  client: '/client/login'
}

export function preferredLoginMode () {
  try {
    const saved = localStorage.getItem(STORAGE_KEY)

    return LOGIN_MODES.includes(saved) ? saved : DEFAULT_MODE
  } catch (e) {
    // Приватный режим и запрет хранилища не должны ронять страницу входа.
    return DEFAULT_MODE
  }
}

export function saveLoginMode (mode) {
  const value = LOGIN_MODES.includes(mode) ? mode : DEFAULT_MODE

  try {
    localStorage.setItem(STORAGE_KEY, value)
  } catch (e) {
    // Не запомнили — не беда: форма всё равно откроется, просто по умолчанию.
  }

  return value
}
